import { render, staticRenderFns } from "./ImageResponsive.vue?vue&type=template&id=07581a5a&functional=true&"
import script from "./ImageResponsive.vue?vue&type=script&lang=ts&"
export * from "./ImageResponsive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports